import { render, staticRenderFns } from "./CateringSelect.vue?vue&type=template&id=8a6e3fe8&scoped=true"
import script from "./CateringSelect.vue?vue&type=script&lang=js"
export * from "./CateringSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6e3fe8",
  null
  
)

export default component.exports